import * as React from "react";
import { useContext } from "react";
import styled, { css } from "styled-components";
import IconButton from "components/common/IconButton";
import { ButtonToolbar } from "components/bootstrap";
import ExpandedEntitiesSectionsContext from "./contexts/ExpandedSectionsContext";
const Container = styled.tr(
  ({ theme }) => css`
    &&&& {
      background-color: ${theme.colors.global.contentBackground};
    }
  `
);
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;
const Actions = styled(ButtonToolbar)`
  display: flex;
  align-items: center;
`;
const HideSectionButton = styled(IconButton)`
  margin-left: 5px;
`;
const ExpandedSections = ({
  expandedSectionRenderers,
  entity
}) => {
  const { expandedSections, toggleSection } = useContext(ExpandedEntitiesSectionsContext);
  const expandedEntitySections = expandedSections == null ? void 0 : expandedSections[entity.id];
  if (!(expandedEntitySections == null ? void 0 : expandedEntitySections.length)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("td", { colSpan: 1e3 }, Object.entries(expandedSectionRenderers != null ? expandedSectionRenderers : {}).filter(([sectionName]) => expandedEntitySections.includes(sectionName)).map(([sectionName, section]) => {
    var _a;
    const hideSection = () => toggleSection(entity.id, sectionName);
    const actions = (_a = section.actions) == null ? void 0 : _a.call(section, entity);
    return /* @__PURE__ */ React.createElement("div", { key: `${sectionName}-${entity.id}` }, section.disableHeader !== true ? /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("h3", null, section.title), /* @__PURE__ */ React.createElement(Actions, null, actions, /* @__PURE__ */ React.createElement(HideSectionButton, { name: "close", onClick: hideSection, title: "Hide section" }))) : null, section.content(entity));
  })));
};
export default ExpandedSections;
